export default __webpack_public_path__ + "static/media/eth.5f5783f7.png";